import cn from "classnames";
import { useCallback, useRef } from "react";
import tippy, { type Instance } from "tippy.js";
import { capitalize } from "../../lib";
import type { EmojiItem } from "../../model";
import { getEmojiSymbolById } from "../Emoji";
import styles from "./EmojiPanelItem.module.scss";

type Props = {
    emoji: EmojiItem;
    onClick: (emoji: EmojiItem) => void;
    disableTooltip?: boolean;
    size: "s" | "m";
};

export function EmojiPanelItem({ emoji, onClick, disableTooltip, size }: Props) {
    const instanceRef = useRef<Instance | null>(null);

    const emojiRef = useCallback(
        (node: HTMLDivElement | null) => {
            if (instanceRef.current) {
                instanceRef.current.destroy();
                instanceRef.current = null;
            }

            if (node && !disableTooltip) {
                instanceRef.current = tippy(node, {
                    content: capitalize(emoji?.descriptionLocal || emoji.description),
                    placement: "bottom",
                    offset: [4, 0],
                    delay: [800, -1],
                });
            }
        },
        [emoji, disableTooltip],
    );

    const handleClick = () => onClick(emoji);
    const emojiSymbol = getEmojiSymbolById(emoji.id);

    return (
        <div
            ref={emojiRef}
            className={cn(styles.emojiButton, styles[`emojiButtonSize${capitalize(size)}`])}
            onClick={handleClick}
            data-emoji-font="true"
            data-id={emoji.id}
        >
            {emojiSymbol}
        </div>
    );
}
